import { useToastContext } from '../context/ToastProvider';

export function useToast() {
  const { add, remove } = useToastContext();
  return {
    success: (msg, duration)  => add(msg, 'success', duration),
    error:   (msg, duration)  => add(msg, 'error',   duration),
    warning: (msg, duration)  => add(msg, 'warning', duration),
    info:    (msg, duration)  => add(msg, 'info',    duration),
    dismiss: (id)             => remove(id),
  };
}
